<template>
    <div>
        <van-tabs color="#fff" :border="true" title-active-color="#5878FA" title-inactive-color="#979797" sticky>
            <van-tab title="产品介绍">
                <img v-for="(item, index) in src" :src="item" alt="产品介绍" style="width: 100%"/>
            </van-tab>
            <van-tab title="质量承诺">
              <static-doc></static-doc>
            </van-tab>
            <van-tab title="产品手册">
              <pdf-list :type="1"></pdf-list>
            </van-tab>
          <van-tab title="用户评论" style="text-align: center;">
              <p style="font-size: 14px">用户评论暂未开放</p>
          </van-tab>
        </van-tabs>
    </div>
</template>
<style>

</style>
<script>
import StaticDoc from '../../multiplex/StaticDoc'
import PdfList from '../../BoSolution/PdfList'
export default {
  components: {PdfList, StaticDoc},
  data () {
    return {
      src: [],
      imgLength: 25
    }
  },
  mounted () {
    this.setSrc()
  },
  methods: {
    setSrc () {
      for (let i = 1; i < (this.imgLength + 1); i++) {
        let url = '/emktResources/resocurces/img/proteomicsDetail/产品详情'
        url = url + i + '.png'
        this.src.push(url)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProteomicsDesc.vue?72476b13